import { Locale, defaultNS } from "types/locale";

import { AppRoute } from "./AppFlow";

export const enum BFFError {
  DEFAULT_ERROR = "BFF-000000",
  EXPIRED_SESSION = "BFF-00005",
  WRONG_DEVICE = "BFF-00006",
}

// Not all errors map to an app route i.e. DEFAULT_ERROR
type ErrorPageMap = Partial<Record<BFFError, AppRoute>>;

export const errorMap: ErrorPageMap = {
  [BFFError.EXPIRED_SESSION]: AppRoute.ExpiredSession,
  [BFFError.WRONG_DEVICE]: AppRoute.WrongDevice,
};

export const DAMAGED_PARTS_POLL_DURATION = 59;
export const ESTIMATE_POLL_DURATION = 89;

// We adjust the poll duration for dev specifically, as the API is much slower. This is to prevent
// the polling from timing out and the estimate not being displayed.
export const ESTIMATE_POLL_DURATION_DEV = 600;

export const i18nextConfig = {
  fallbackLng: Locale.English_GB, // Ensures English content will be used if in primary locale is missing/empty string
  defaultNS: defaultNS,
  load: "currentOnly" as const,
  returnEmptyString: false,
  react: {
    transKeepBasicHtmlNodesFor: ["b"],
  },
};
